import gql from 'graphql-tag';

export const getPropertyTenantDomainsQuery = gql`
  query listPropertyTenantDomains(
    $propertyId: UUID!
    $first: Int
    $start: Int
    $perPage: Int
  ) {
    property(propertyId: $propertyId) {
      domains(first: $first, start: $start, perPage: $perPage) {
        edges {
          cursor
          node {
            domain
          }
        }
        pageInfo {
          total
        }
      }
    }
  }
`;

